import React, {FC, useState} from 'react'
import {useIntl} from 'react-intl'

import {useAuth} from '@modules/auth'
import useIsPremium from '@app/hooks/useIsPremium'
import useIsMobileIOSCookieTrue from '@app/hooks/useIsMobileIOSCookieTrue'

import {useSubscriptionModalStore} from '@components/molecules/SubscriptionModal/SubscriptionModal'
import {useCurrentSubscriptionModalStore} from '@components/molecules/CurrentSubscriptionModal/CurrentSubscriptionModal'
import {useTreesStore} from '@store/trees'
import {useUserProfileDrawerStore} from '@_metronic/partials/layout/userprofile-drawer/UserProfileDrawer'

import ImportTreeModal from '@components/molecules/ImportTreeModal'

const ToggleUserProfileDrawer: FC = () => {
  const intl = useIntl()

  const [importTreeModalOpen, setImportTreeModalOpen] = useState(false)
  const {show: showSubscriptionModal} = useSubscriptionModalStore()
  const openUserProfileSidebar = useUserProfileDrawerStore((state) => state.open)

  const {currentUser} = useAuth()
  const is_premium = useIsPremium()

  const {trees} = useTreesStore()
  const handleOpenTreeModalClick = () => {
    if (!is_premium && Object.keys(trees).length >= 2) {
      showSubscriptionModal()
    } else {
      setImportTreeModalOpen(true)
    }
  }

  const {show: showCurrentSubscriptionModal} = useCurrentSubscriptionModalStore()
  const handleSubscriptionClick = () => {
    if (is_premium) {
      showCurrentSubscriptionModal()
    } else {
      showSubscriptionModal()
    }
  }

  const handleCloseTreeModalClick = () => {
    setImportTreeModalOpen(false)
  }

  const isMobileIOSCookieTrue = useIsMobileIOSCookieTrue()

  return (
    <>
      <div
        className='engage-help-toggle menu-item px-5'
        data-bs-toggle='tooltip'
        data-bs-placement='left'
        data-bs-dismiss='click'
        data-bs-trigger='hover'
        onClick={openUserProfileSidebar}
      >
        <div className='menu-link px-5'>{intl.formatMessage({id: 'MENU.PROFILE'})}</div>
      </div>

      {currentUser?.role === 1 && (
        <div className='menu-item px-5'>
          <a
            href='https://creator.thesimstree.com'
            target='_blank'
            className='menu-link px-5'
            rel='noreferrer'
          >
            {intl.formatMessage({id: 'MENU.TST_CREATOR'})}
          </a>
        </div>
      )}

      {!isMobileIOSCookieTrue && (
        <div className='menu-item px-5'>
          <div className='menu-link px-5' onClick={handleSubscriptionClick}>
            {intl.formatMessage({id: 'MENU.SUBSCRIPTION'})}
          </div>
          <ImportTreeModal show={importTreeModalOpen} onClose={handleCloseTreeModalClick} />
        </div>
      )}

      <div className='engage-help-toggle menu-item px-5'>
        <div className='menu-link px-5' onClick={handleOpenTreeModalClick}>
          {intl.formatMessage({id: 'MENU.IMPORT_DYNASTY'})}
        </div>
        <ImportTreeModal show={importTreeModalOpen} onClose={handleCloseTreeModalClick} />
      </div>
    </>
  )
}

export {ToggleUserProfileDrawer}
